<template>
	<div class="VipRight">
		<div class="PubBox Boxs   ZAuto">
			 
			<div class="QuickNavigation">
				<div class="cone_left-title">
					<div class="title-sub">
						我的题库
					</div>
					 
				</div>
				 
			 <div class="tabBody">
			 	
			 	<div :class="{tabItem:true,tabActiveItem:studytab2 == index}" @click="studyzl(index)" v-for="(item,index) in wdkclist">
			 		{{ item.title }}
			 		<div class="cpage-tabitem-line" v-show="studytab2 == index"></div>
			 	</div>
			 	 
			 </div>
				 
					 
						<div class="nkclist" v-for="(item,index) in wdkclist" v-show="studytab2 == index">
							<el-row>
							  
							  <el-button size="small" round v-for="(item1, index1) in item.child" :key="index1" @click="changecid(item1.cid)" >
							  {{ item1.title}}
							  </el-button>
							  
							</el-row>
						
						 
					 
							
					</div>
					 
				<!-- <Tabs value="name1">
				         <Tab-pane label="标签一" name="name1">
							 <Tabs value="name11">
							         <Tab-pane label="标签一" name="name11">标签一的内容</Tab-pane>
							         <Tab-pane label="标签二" name="name22">标签二的内容</Tab-pane>
							         <Tab-pane label="标签三" name="name33">标签三的内容</Tab-pane>
							     </Tabs>
						 </Tab-pane>
				         <Tab-pane label="标签二" name="name2">标签二的内容</Tab-pane>
				         <Tab-pane label="标签三" name="name3">标签三的内容</Tab-pane>
				     </Tabs> -->
			</div>
			<div class="QuickNavigation" style="margin-top:20px">
				 <Tkttlist v-if="questionLoaded" :bank="bankId"  :list="studyTabList1"></Tkttlist>
			</div>



		</div>


	</div>
</template>
<script>
	import {
		getCourseList,
		 getCourseDetail,
		getQuestionByCid,
		getCourseWare,
		studyList,
		updateVideo,
		accessStatistical,
		updateRecord,
		getCourseRecordList
	} from "../../api/api";
	import Kclist from "./kc_list.vue";
	import Tkttlist from "./tk_tt.vue";
 
	export default {
		props: {
			  
		},
		data() {
			return {
				studytab2:0,
				alllist:[],
				bankId: "",
				 kckjlist:[],
				 kckjtitle:"",
				courseId:0,
				coursekjId:0,
				listshowid: 0,
				studytab1: 0,
				liststatus: false,
				studyTab: {},
				studyTabList: [],
				 
				catalogList: [],
				wdkclist: [],
			 
				currentOffset: 0,
				windowSize: 3,
				paginationFactor: 220,
				 questionLoaded:"",
				activeName: 'second'
			};
		},
		mounted() {
			 this.$nextTick(function () {
				 this.getulist()
				 
				// this.getQuestionList()
				 
			})
		 
		}, 
		computed: {
			ncid:function(){
				 return this.courseId
			},
			tkcId:function(){
				return this.bankId
			},
			studyTabList1:function(){
				return this.studyTabList
			}
 
		},
		methods: {
			initTabData() {
			  if (this.studyTabList.length > 0) {
			    this.studyTab = this.studyTabList[0];
			  }
			  if (this.studyTab.list.length > 0){
			    this.subjectList = this.studyTab.list
			    this.liststatus = true
			  }
			},
			studyzl(index){
				this.studytab2=index;
				console.log(this.studytab2);
			},
			mykclist(index) {
				this.listshowid = index
			},
			changecid(cid){
				this.courseId = cid;
				console.log("courseId:"+this.courseId)
				 var _this = this
				 getCourseDetail({
				   cid: cid
				 }).then((res) => {
				   if (res.code == 1) {
				     	
				     console.log("res.data.link_bank:")
				 		console.log(res.data)	 
				     // _this.changeVideo(_this.currentSpecial.video_list[0]);
				     _this.bankId = res.data.link_bank.category_id;
				   getQuestionByCid({bankId: _this.bankId}).then((res) => {
				     if(res.code == 1){
				       this.studyTabList = res.data
					    console.log("thisbankId")
					    console.log(this.bankId)
				    console.log("studyTabList")
				    				 		console.log(this.studyTabList)	 
				       _this.questionLoaded = true
				     }
				   })
				 					 
				     
				   }
				 });
				        
				      
			},
			 
			getulist(){
				getCourseList({})
					.then(res => {
						if (res.code == 1) {
							let listx = res.data.course_list;
							this.wdkclist = listx;
						 
							if(this.wdkclist.length>0){
								this.wdkclist.forEach((itme,index)=>{
									
									if(index == 0){
										 
										let bkid=itme.child[index].cid;
										this.courseId=itme.child[index].cid 
										this.coursekjId=itme.child[index].cid
										 
										         var _this = this
										         getCourseDetail({
										           cid: itme.child[index].cid
										         }).then((res) => {
										           if (res.code == 1) {
										             
										             // _this.changeVideo(_this.currentSpecial.video_list[0]);
										             _this.bankId = res.data.link_bank.category_id;
										            getQuestionByCid({bankId:_this.bankId}).then((res) => {
										              if(res.code == 1){
										                _this.studyTabList = res.data
										             console.log("111111111111111")
										             console.log(_this.bankId)
										             console.log("222222222222")
										             console.log(this.studyTabList)
										                _this.questionLoaded = true
										              }
										            })
										 						
										              
										           }
										         });
										       
									}
								})
							}else{
								console.log('这是不大于0')
							}
							this.youxiaoCount = res.data.count;
						} else if (res.code == -2) {
							// this.$Message.info('登陆超时，请重新登录');
							this.$router.push('/login')
						}
					})
				  
			},
			 getCourseSpecialType() {
			         var _this = this
			         getCourseDetail({
			           cid: this.courseId
			         }).then((res) => {
			           if (res.code == 1) {
			             _this.courseInfo = res.data.course_detail;
			             _this.specialList = res.data.contents;
			             _this.currentSpecial = _this.specialList[0];
						
			             
			 
			             // _this.changeVideo(_this.currentSpecial.video_list[0]);
			             _this.bankId = res.data.link_bank.category_id;
			             _this.getQuestionList()
						console.log("111111111111111")
						console.log(_this.bankId)
						console.log("222222222222")
						console.log(_this.getQuestionList())
			             this.$nextTick(() => {
			               this.videoPlayer = this.$refs.video.player;
			             })
			           }
			         });
			       },
			 
			moveCarousel(direction) {
				// Find a more elegant way to express the :style. consider using props to make it truly generic
				if (direction === 1 && !this.atEndOfList) {
					this.currentOffset -= this.paginationFactor;
				} else if (direction === -1 && !this.atHeadOfList) {
					this.currentOffset += this.paginationFactor;
				}
			},
			handleClick(tab, event) {
				console.log(tab, event);
			},
			getData() {
				this.catalogList = this.subjectList;
				this.catalogList.forEach((item, index) => {
					if (index === 0) {
						this.$set(item, "visible", true);
					} else {
						this.$set(item, "visible", false);
					}

				});
			},
			
		},
		components: {
			 
			 Tkttlist
		},
	};
</script>
<style lang="less" scoped>
	.nkclist{
		padding:20px 50px; 
	}
	.VipRight {
		width: 1030px;
		float: right;
	}

	.QuickNavigation {
		background: #fff;
		margin-bottom: 20px;
	}

	.title-sub {
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #111;
		position: relative;
		padding: 20px 0;
		padding-left: 35px;
	}

	.title-sub:before {
		position: absolute;
		left: 26px;
		top: 25px;
		content: "";
		width: 3px;
		height: 21px;
		background: #3477ff;
	}

	.cone_left-title .title-sub {
		font-size: 20px;
	}

	.flex-align-items,
	.flex-items-justify-content {
		display: flex;
		align-items: center;
	}

	.QuickNavigation-list {
		text-align: center;
		cursor: pointer;
		margin: 0 25px;
	}

	.QuickNavigation-list .img {
		width: 45px;
		height: 45px;
		margin: 0 auto;
		display: block;
		margin-bottom: 10px;
		border-radius: 10px;
	}

	.right-content {
		padding: 20px;
		position: relative;
	}

	.QuickNavigation-list .title {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333;
		line-height: 24px;
		padding-bottom: 20px;
	}

	.card-carousel-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		// margin: 20px 0 40px;
		color: #666a73;
	}

	.card-carousel {
		display: flex;

		width: 100%;
	}

	.card-carousel--overflow-container {
		overflow: hidden;
	}

	.card-carousel--nav__left,
	.card-carousel--nav__right {
		display: inline-block;
		width: 15px;
		height: 15px;
		padding: 10px;
		box-sizing: border-box;
		border-top: 2px solid #42b883;
		border-right: 2px solid #42b883;
		cursor: pointer;
		margin: 0 10px;
		transition: transform 150ms linear;
	}

	.card-carousel--nav__left[disabled],
	.card-carousel--nav__right[disabled] {
		opacity: 0.2;
		border-color: black;
	}

	.card-carousel--nav__left {
		transform: rotate(-135deg);
	}

	.card-carousel--nav__left:active {
		transform: rotate(-135deg) scale(0.9);
	}

	.card-carousel--nav__right {
		transform: rotate(45deg);
	}

	.card-carousel--nav__right:active {
		transform: rotate(45deg) scale(0.9);
	}

	.card-carousel-cards {
		display: flex;
		transition: transform 150ms ease-out;
		transform: translatex(0px);
	}

	.card-carousel-cards .card-carousel--card {
		width: 220px;
		margin: 0 10px;
		cursor: pointer;
		// box-shadow: 0 4px 15px 0 rgb(124 125 128 / 6%), 0 2px 2px 0 rgb(40 44 53 / 8%);
		background-color: #fff;
		border-radius: 4px;
		z-index: 3;
		margin-bottom: 2px;
	}

	.card-carousel-cards .card-carousel--card:first-child {
		margin-left: 0;
	}

	.card-carousel-cards .card-carousel--card:last-child {
		margin-right: 0;
	}

	.card-carousel-cards .card-carousel--card--footer {
		border-top: 0;
		padding: 7px 15px;
		height: 68px;
	}

	.card-carousel-cards .card-carousel--card--footer p {
		padding: 15px 0;
		text-align: center;
		font-size: 19px;
		font-weight: 500;
		color: #fff;
		user-select: none;
	}

	.card-carousel-cards .card-carousel--card--footer p:nth-of-type(2) {
		font-size: 12px;
		font-weight: 300;
		padding: 6px;
		background: rgba(40, 44, 53, 0.06);
		display: inline-block;
		position: relative;
		margin-left: 4px;
		color: #666a73;
	}

	.card-carousel-cards .card-carousel--card--footer p:nth-of-type(2):before {
		content: "";
		float: left;
		position: absolute;
		top: 0;
		left: -12px;
		width: 0;
		height: 0;
		border-color: transparent rgba(40, 44, 53, 0.06) transparent transparent;
		border-style: solid;
		border-width: 12px 12px 12px 0;
	}

	.card-carousel-cards .card-carousel--card--footer p:nth-of-type(2):after {
		content: "";
		position: absolute;
		top: 10px;
		left: -1px;
		float: left;
		width: 4px;
		height: 4px;
		border-radius: 2px;
		background: white;
		box-shadow: -0px -0px 0px #004977;
	}

	.bg_q {
		background: #71c8cf;
		    box-shadow: 4px 1px 8px 0 rgb(217 213 213 / 74%);
		border-radius: 4px;
		height: 80px;
		overflow: hidden;
	}
	.tabBody{
		display: flex;
		    align-items: center;
		    justify-content: center;
		    color: #555;
		    font-size: 18px;
		    background: #fff;
		    flex-wrap: wrap;
		    padding: 0 24px;
	}
	.QuickNavigation .tabBody{
		width: 574px;
		    margin: 0 auto;
		    border-bottom: 1px solid #e6e6e6;
	 
	}
	.tabItem{
		margin: 15px 70px 0 70px;
		    padding-bottom: 18px;
		    cursor: pointer;
		    position: relative;
	}
	.tabActiveItem{
		color: #2d83f3;
		    font-weight: 700;
	}
	.cpage-tabitem-line{
		width: 100%;
		    height: 2px;
		    position: absolute;
		    bottom: 0;
		    right: 0;
		    background-color: #2d83f3;
	}
</style>
